import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeEarnedLeaveModal, fetchEarnedLeave, openEarnedLeaveModal } from "./store/earnedLeaveSlice";
import EarnedLeaveDataTable from "./EarnedLeaveDataTable";
import AddEarnedLeave from "./AddEarnedLeave";

const EarnedLeave = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.earnedLeaveData || {});

  useEffect(() => {
    dispatch(fetchEarnedLeave());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Earned Leave"
            title="Dashboard"
            subtitle="Earned Leave"
            name="Import Earned Leave"
            onAddClick={() => dispatch(openEarnedLeaveModal())}
          />

          <EarnedLeaveDataTable data={data} loading={loading} />

          <AddEarnedLeave
            show={isModalOpen}
            onClose={() => dispatch(closeEarnedLeaveModal())}
          />
        </div>
      </div>
    </div>
  );
};

export default EarnedLeave;
